import { useInfiniteQuery } from "@tanstack/react-query";
import type { ChatMessagesPage, ChatThreadsPage } from "./models";
import {
  fetchChatThreadMessages,
  fetchChatThreads
} from "./service";
import {
  DEFAULT_MESSAGES_PAGE_SIZE,
  DEFAULT_THREADS_PAGE_SIZE
} from "./config";

export function useChatThreads(pageSize: number = DEFAULT_THREADS_PAGE_SIZE) {
  return useInfiniteQuery<ChatThreadsPage>({
    queryKey: ["chatHistory", "threads", pageSize],
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.threads.length < lastPage.limit) {
        return undefined;
      }
      return allPages.length;
    },
    queryFn: async ({ pageParam }) => {
      const page = typeof pageParam === "number" ? pageParam : 0;
      return fetchChatThreads(page, pageSize);
    }
  });
}

export function useChatThreadMessages(
  threadId: string | null,
  pageSize: number = DEFAULT_MESSAGES_PAGE_SIZE
) {
  return useInfiniteQuery<ChatMessagesPage>({
    queryKey: ["chatHistory", "thread", threadId, pageSize],
    enabled: Boolean(threadId),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.messages.length < lastPage.limit) {
        return undefined;
      }
      return allPages.length;
    },
    queryFn: async ({ pageParam }) => {
      const page = typeof pageParam === "number" ? pageParam : 0;
      return fetchChatThreadMessages(threadId as string, page, pageSize);
    }
  });
}

